<template>
  <div class="settingsWrapper">
    <div class="inner w-100 text-center pb-2">
      <b-button size="sm" @click="leaveRoom()" variant="primary"
        >Leave Room</b-button
      >
    </div>
    <unicon name="cog" />
    <b-modal 
      centered 
      button-size="sm"
      v-model="leaveRoomConfirmModal"
      :hide-header="true"
      @ok="leaveRoom()"
    >
      Are you sure to leave this room ?
    </b-modal>
  </div>
</template>
<script>
import server from "@/server";
import store from "@/store";
export default {
  methods: {
    leaveRoom: () => {
      server.leaveRoom();
    }
  },
  computed: {
    gameStarted: () => store.state.room.gameStarted,
    leaveRoomConfirmModal: {
            get() {
                return store.state.room.leaveRoomConfirmModal;
            },
            set(value) {
                store.state.room.leaveRoomConfirmModal = value;
            },
        }
  }
};
</script>
